import React, { useEffect, useState } from 'react';
import { Box, Typography, Card, CardContent, TextField, Button, Grid, Switch, FormControlLabel, Alert } from '@mui/material';
import { Save, Send } from '@mui/icons-material';
import { smtpAPI } from '../../services/api';
import { useSnackbar } from '../../utils/notify';
import { useBranding } from '../../contexts/BrandingContext';

export default function SMTPSettings() {
  const { enqueueSnackbar } = useSnackbar();
  const branding = useBranding();
  const [config, setConfig] = useState({ host: '', port: 587, username: '', password: '', from_email: '', from_name: branding.portal_name, use_tls: true });

  useEffect(() => {
    smtpAPI.get().then((r) => { if (r.data.data) setConfig({ ...config, ...r.data.data, password: '' }); });
  }, []);

  const save = async () => {
    try {
      await smtpAPI.save(config);
      enqueueSnackbar('SMTP config saved', { variant: 'success' });
    } catch (err) { enqueueSnackbar((err.response && err.response.data && err.response.data.error) || 'Failed', { variant: 'error' }); }
  };

  const test = async () => {
    try {
      const res = await smtpAPI.test();
      enqueueSnackbar(res.data.message, { variant: 'success' });
    } catch (err) { enqueueSnackbar((err.response && err.response.data && err.response.data.error) || 'Test failed', { variant: 'error' }); }
  };

  return (
    <Box>
      <Typography variant="h4" sx={{ mb: 3 }}>SMTP Settings</Typography>
      <Card>
        <CardContent>
          <Grid container spacing={2}>
            <Grid item xs={12} md={8}>
              <TextField fullWidth label="SMTP Host" value={config.host}
                onChange={(e) => setConfig({ ...config, host: e.target.value })} />
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField fullWidth label="Port" type="number" value={config.port}
                onChange={(e) => setConfig({ ...config, port: parseInt(e.target.value) })} />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField fullWidth label="Username" value={config.username}
                onChange={(e) => setConfig({ ...config, username: e.target.value })} />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField fullWidth label="Password" type="password" value={config.password}
                onChange={(e) => setConfig({ ...config, password: e.target.value })}
                helperText="Leave blank to keep existing password" />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField fullWidth label="From Email" value={config.from_email}
                onChange={(e) => setConfig({ ...config, from_email: e.target.value })} />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField fullWidth label="From Name" value={config.from_name}
                onChange={(e) => setConfig({ ...config, from_name: e.target.value })} />
            </Grid>
            <Grid item xs={12}>
              <FormControlLabel control={<Switch checked={config.use_tls}
                onChange={(e) => setConfig({ ...config, use_tls: e.target.checked })} />} label="Use TLS" />
            </Grid>
            <Grid item xs={12}>
              <Box sx={{ display: 'flex', gap: 2 }}>
                <Button variant="contained" startIcon={<Save />} onClick={save}>Save Config</Button>
                <Button variant="outlined" startIcon={<Send />} onClick={test}>Send Test Email</Button>
              </Box>
            </Grid>
          </Grid>
          <Alert severity="info" sx={{ mt: 2 }}>
            SMTP password is encrypted at rest using AES-256-GCM. Test email is sent to your admin email address.
          </Alert>
        </CardContent>
      </Card>
    </Box>
  );
}
